import { useQuery } from "@apollo/client/react";

import { BitbucketDatacenterIntegration, Maybe } from "types/generated";

import { CHECK_BITBUCKET_DATA_CENTER_HAS_DEFAULT_INTEGRATION } from "./gql";

const useCheckBitbucketDataCenterHasDefaultIntegration = (skip: boolean) => {
  const { data, loading } = useQuery<{
    checkBitbucketDataCenterHasDefaultIntegration: Maybe<
      Pick<BitbucketDatacenterIntegration, "id">
    >;
  }>(CHECK_BITBUCKET_DATA_CENTER_HAS_DEFAULT_INTEGRATION, {
    fetchPolicy: "no-cache",
    skip,
  });

  return {
    hasDefaultIntegration:
      typeof data?.checkBitbucketDataCenterHasDefaultIntegration?.id !== "undefined",
    loading,
  };
};

export default useCheckBitbucketDataCenterHasDefaultIntegration;
